import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  CreatableDropdown,
  Props as CreatableDropdownProps,
} from '../../Select/CreatableDropdown';
import InputError from '../InputError';
import { getError } from '../utils';

type Props = Omit<CreatableDropdownProps, 'value' | 'onChange'> & {
  name: string;
  onSelect?: (value: string | null) => void;
};

export const CreatableDropdownControlled: React.FC<
  React.PropsWithChildren<Props>
> = ({ name, onSelect, ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = getError(name, errors);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <CreatableDropdown
            {...props}
            className={[props.className, error ? 'is-invalid' : null]
              .filter(Boolean)
              .join(' ')}
            value={field.value ?? null}
            onChange={(value) => {
              field.onChange(value);
              onSelect?.(value);
            }}
            error={error !== undefined}
          />
        )}
      />
      <InputError error={error} />
    </>
  );
};
